// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

// Form bölüm başlığı stili ürün markasına göre değişebilir (kullanıcı kararı 2026-08-15, ELPO CX:
// SmartŞarj'ın alt-çizgili sade başlık dili). Renderer marka bilmez — UI paketi brand verisinden
// register eder (lookupResolver deseniyle aynı). Varsayılan mevcut görünümdür; kayıt yoksa hiçbir
// ürün etkilenmez.

/** 'accent' = sol-şeritli mevcut başlık; 'underline' = SmartŞarj tarzı alt-çizgili sade başlık. */
export type FormSectionStyle = 'accent' | 'underline';

let _style: FormSectionStyle = 'accent';

export function registerFormSectionStyle(style: FormSectionStyle): void {
  _style = style;
}

export function getFormSectionStyle(): FormSectionStyle {
  return _style;
}
